import React from "react";
import { Button, Label } from "usebeauty";
import classNames from "classnames";
import { useOCRContext } from "@context/OCRContext";
import { useRoutes } from "@router/Router";
import { Back, ChevronLeft, Close } from "@Icons";
import "./CardSelectPage.scss";

const CardSelectPage = () => {
  const { step, navigate } = useRoutes();
  const ocrContext = useOCRContext();
  const { ocrType, handlers } = ocrContext;

  const prevHandler = () => {
    handlers.setOcrType("idcard-ssa");
    navigate("prev");
  };

  return (
    <div className="alchera-demo-card-select">
      <div className="navigation">
        {step.prev && (
          <i onClick={prevHandler}>
            <Back st={{ color: "#000038", fontSize: "16px" }} />
          </i>
        )}
        <Label text={step.label}></Label>
        <i onClick={() => window.location.reload()}>
          <Close st={{ color: "#000038", fontSize: "16px" }} />
        </i>
      </div>
      <div className="container">
        <div className="description">
          <p>
            <b>신분증 종류 선택 후</b>
          </p>
          <p>다음을 눌러주세요.</p>
        </div>
        <div className="alchera-ocr-type">
          <div
            className={classNames("ocr-type", { active: ocrType === "idcard-ssa" })}
            onClick={() => handlers.setOcrType("idcard-ssa")}>
            <div>주민등록/운전면허증</div>
          </div>
          <div
            className={classNames("ocr-type", { active: ocrType === "passport-ssa" })}
            onClick={() => handlers.setOcrType("passport-ssa")}>
            <div>국내여권</div>
          </div>
          <div
            className={classNames("ocr-type", { active: ocrType === "foreign-passport-ssa" })}
            onClick={() => handlers.setOcrType("foreign-passport-ssa")}>
            <div>해외여권</div>
          </div>
          <div
            className={classNames("ocr-type", { active: ocrType === "alien-ssa" })}
            onClick={() => handlers.setOcrType("alien-ssa")}>
            <div>외국인등록증</div>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="steps">
          <span>Step 1</span>
          <div className="step">
            <div className="level current"></div>
            <div className="level"></div>
            <div className="level"></div>
            <div className="level"></div>
          </div>
        </div>
        <Button onClick={() => navigate("next")} ripple={false}>
          <span>다음</span>
          <ChevronLeft st={{ fontSize: "20px" }} />
        </Button>
      </div>
    </div>
  );
};

export default CardSelectPage;
